// ============================================================
// Brand Configuration
// Single source of truth for brand-specific values.
// When cloning a new brand, change only this file.
// ============================================================

export interface BrandConfig {
  name: string;
  nameEn: string;
  legalName?: string;
  siteUrl: string;
  domain: string;
  logo: string;
  favicon: string;
  colors: {
    primary: string;
    primaryDark: string;
    secondary: string;
    accent: string;
    bg: string;
    bgCard: string;
    border: string;
    textMain: string;
    textSub: string;
    whatsapp: string;
  };
  contact: {
    businessPhone: string;
    adminPhone: string;
    whatsappNumber: string;
    facebookUrl: string;
    email?: string;
  };
  social: {
    facebook: string;
  };
  tagline: string;
  copyright: string;
}

export const brand: BrandConfig = {
  name: '阿力廚房',
  nameEn: 'Alex Kitchens',
  legalName: '阿力廚房 Alex Kitchens',
  siteUrl: 'https://alexkitchens.com',
  domain: 'alexkitchens.com',
  logo: '/src/assets/alex-kitchens-logo.jpg',
  favicon: '/src/assets/alex-kitchens-logo.jpg',
  colors: {
    primary: '#E8593C',     // 辣紅
    primaryDark: '#C73E2A', // 深辣紅
    secondary: '#EF9F27',   // 琥珀金
    accent: '#25D366',      // WhatsApp 綠
    bg: '#0F0F0F',          // 深炭背景
    bgCard: '#1A1A1A',      // 卡片背景
    border: '#2A2A2A',      // 邊框
    textMain: '#F5F0E8',    // 主文字
    textSub: '#B0A898',     // 次要文字
    whatsapp: '#25D366',    // WhatsApp 按鈕
  },
  contact: {
    businessPhone: '85260771493',
    adminPhone: '85260771493',
    whatsappNumber: '85260771493',
    facebookUrl: 'https://www.facebook.com/profile.php?id=100064050482929',
  },
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=100064050482929',
  },
  tagline: '私廚出品 · 辣醒你嘅味蕾',
  copyright: '© 2025 阿力廚房 Alex Kitchens · Powered by 香港辣谷',
};
